import {
  GET_ALL_UNVERIFIED_LICENSES_REQUEST,
  GET_ALL_UNVERIFIED_LICENSES_SUCCESS,
  GET_CREDENTIALS_V2_REQUEST,
  GET_CREDENTIALS_V2_SUCCESS,
  CREDENTIAL_ACTION,
} from '../actions/actionTypes';

const defaultState = {
  licenses: [],
  credentialsV2: [],
  totalLicenses: 0,
  totalCredentialsV2: 0,
  searchParams: {
    page: 1,
    status: '',
    profession: '',
    state: '',
  },
  stateCredentials: {},
};

export default (state = defaultState, action) => {
  switch (action.type) {
  case GET_ALL_UNVERIFIED_LICENSES_REQUEST:
    return {
      ...state,
      searchParams: action.payload,
    };
  case GET_ALL_UNVERIFIED_LICENSES_SUCCESS:
    if (!action.payload.response) {
      return state;
    }

    return {
      ...state,
      licenses: action.payload.response,
      totalLicenses: action.payload.total,
    };
  case GET_CREDENTIALS_V2_REQUEST:
    return {
      ...state,
      searchParams: action.payload,
      credentialsV2: [],
      totalCredentialsV2: 0,
    };
  case GET_CREDENTIALS_V2_SUCCESS:
    if (!action.payload.credentials) {
      return state;
    }

    return {
      ...state,
      credentialsV2: action.payload.credentials,
      totalCredentialsV2: action.payload.total,
    };
  case CREDENTIAL_ACTION.GET_ALL_STATE_CREDENTIALS_SUCCESS:
    if (!action.payload) {
      return state;
    }

    return {
      ...state,
      stateCredentials: action.payload,
    };
  default:
    return state;
  }
};
